const basePath = "/api/v1"

export const apiPaths = {
    application: `${basePath}/application`,
    analytics: `${basePath}/analytics`,
    Oauth: `${basePath}`,
    sessionTimeout: `${basePath}/session-timeout`,
    keepAlive: `${basePath}/keep-alive`
}